import Vue from 'vue'
import SvgIcon from '@/basecomponents/SvgIcon'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
requireAll(req)



// WEBPACK FOOTER //
// ./src/assets/icons/index.js